// src/components/layout/Footer.tsx
import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const palette = {
  bg: "#EEF5FF",
  panel: "#B4D4FF",
  border: "#86B6F6",
  accent: "#176B87",
  ink: "#0B2230",
  muted: "rgba(11,34,48,0.55)",
};

const NAV_LINKS = [
  { label: "Dashboard", href: "/stats" },
  { label: "Team Performance", href: "/performance" },
  { label: "Comparison", href: "/comparison" },
  { label: "Table View", href: "/table" },
  { label: "World Cup", href: "/world" },
];

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: palette.bg,
        borderTop: `1px solid ${palette.border}`,
        px: { xs: 2, sm: 4 },
        pt: 2.5,
        pb: 2,
        mt: "auto",
      }}
    >
      {/* Nav links row */}
      <Stack
        direction="row"
        spacing={0}
        useFlexGap
        flexWrap="wrap"
        justifyContent="center"
        gap={0.5}
        sx={{ mb: 1.5 }}
      >
        {NAV_LINKS.map((link) => (
          <Box
            key={link.href}
            component="button"
            onClick={() => navigate(link.href)}
            sx={{
              background: "none",
              border: "none",
              cursor: "pointer",
              px: 1.2,
              py: 0.4,
              borderRadius: 1,
              fontSize: 13,
              fontWeight: 700,
              color: palette.accent,
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: palette.panel,
              },
            }}
          >
            {link.label}
          </Box>
        ))}
      </Stack>

      <Divider sx={{ borderColor: `rgba(134,182,246,0.5)`, mb: 1.5 }} />

      {/* Bottom row */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems="center"
        justifyContent="space-between"
        spacing={0.5}
      >
        <Typography variant="body2" sx={{ color: palette.muted, fontSize: 12 }}>
          © 2026 RugbyRadar
        </Typography>

        <Typography variant="body2" sx={{ color: palette.muted, fontSize: 12, textAlign: "center" }}>
          Dataset: International Rugby Results 1871–2022 · Source: Kaggle
        </Typography>

        <Typography variant="body2" sx={{ color: palette.muted, fontSize: 12 }}>
          10 teams · 2,784 matches
        </Typography>
      </Stack>
    </Box>
  );
};

export default Footer;
